import { useIntl } from 'react-intl'
import './VisitProjectSpecItem.scss'

const VisitProjectSpecItem = (props: { label: string; value: string }) => {
    const { label, value } = props

    const componentClass = 'smart-modals-visit-project-specs__details__detail'

    const intl = useIntl()

    return (
        <div className={componentClass}>
            <span>{label}:</span>
            <strong>{value}</strong>
        </div>
    )
}

export default VisitProjectSpecItem
